import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../../tas';
import { REIMAGINED_TAS_APPLICATION_INCLUDES } from 'tio-employee/utils/tas/reimagined-includes';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysTasApplicationsTypeThreeNewRoute extends Route {
  @service declare store: StoreService;
  @service declare reimaginedData: ReimaginedDataService;

  async model(params: Record<string, unknown>) {
    const applicationId = params['tas_application_id'] as string;

    if (this.reimaginedData.isDemoMode) {
      const demoProxy = this.reimaginedData.getDemoTasApplicationProxy(applicationId);
      if (demoProxy) {
        return {
          ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
          applicationId,
          applicationType: 'type-three',
          application: demoProxy as unknown as TasApplicationModel,
        };
      }
    }

    const application = await this.store.findRecord<TasApplicationModel>(
      'tas-application',
      applicationId,
      {
        include: REIMAGINED_TAS_APPLICATION_INCLUDES.join(','),
        reload: true,
      }
    );

    return {
      ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
      applicationId,
      applicationType: 'type-three',
      application,
    };
  }
}
